import axios from 'axios';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { IntervalComment } from '@optiro/types';

import { API_URL } from '@/lib/apiUrl';
import { queryKeys } from '@/lib/queryKeys';
import { Interval } from '@/types/types';

// Deliberately not useApi() — see useIntervalComments.ts.
const axiosInstance = axios.create({ baseURL: API_URL, withCredentials: true });

export const useCreateIntervalComment = (intervalId: Interval['id']) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: { body: string }) => {
      const { data } = await axiosInstance.post<IntervalComment>(
        `/api/v1/intervals/${intervalId}/comments`,
        { interval_comment: payload }
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.intervals.comments(intervalId).queryKey,
      });
    },
  });
};
